// extracted by mini-css-extract-plugin
export default {"overlay":"CorrectFlash_overlay__bdBT+","box":"CorrectFlash_box__OkhZ7","pop":"CorrectFlash_pop__yfuFj"};